/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_AlignmentInputs */



/**

* @param {Home_Stats_AlignmentInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const home_stats_alignment = /** @type {((inputs?: Home_Stats_AlignmentInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_AlignmentInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("de científicos de IA creen que el problema de alineación es real e importante")
});